import { render, staticRenderFns } from "./UserMenuModal.vue?vue&type=template&id=2967da78&scoped=true&"
import script from "./UserMenuModal.vue?vue&type=script&lang=js&"
export * from "./UserMenuModal.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuModal.vue?vue&type=style&index=0&id=2967da78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2967da78",
  null
  
)

export default component.exports